import React from 'react';
import Container from "../../../shared/ui/container/Container";
import SuggestionList from "../../../features/productSearch/ui/suggestions/SuggestionList";
import SearchFilterWidget from "../../../widget/searchProducts/SearchFilterWidget";
import {ProductList} from "../../../features/productSearch";
import ProductLoadMore from "../../../features/productSearch/ui/products/ProductLoadMore";
import styled from "styled-components";
import {ToggleCartButtonIfurn} from "../features/toggle-goods-to-cart";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledWidget = styled.div`
    padding-bottom: 50px;
`
/**
 *  Составной (composed) виджет для хост-приложения IFurn, включающий компоненты:
 *   SuggestionList - подсказки
 *   SearchFilterWidget - фильтр
 *   ProductList - результат поиска
 *   ProductLoadMore - кнопка/механизм подгрузки дополнительных товаров
 *
 * @returns {JSX.Element} -
 */

const IFurnProductSearchWidget = () => {
    return (
        <Container>
            <StyledWidget onClick={(e: any) => e.stopPropagation()}
                          className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('content')}`}>
                <SuggestionList/>
                <SearchFilterWidget/>
                <ProductList ToggleToCartButtonSlot={ToggleCartButtonIfurn}/>
                <ProductLoadMore/>
            </StyledWidget>
        </Container>
    );
};

export default IFurnProductSearchWidget;